import { isProduction } from '../isProduction';

export const getBaseUrl = (): string => {
  if (isProduction()) {
    return 'https://static.stellartech.se';
  }
  return 'https://static.stellartech.isdemo.se';
};
